import Grid from "@mui/material/Grid";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React from "react";
import { DataGridListStyle } from "../../Theme";
import { v4 as uuid } from "uuid";

export default function DrugNotMatchPopUp(props: any) {
  const { matchingDrugList } = props;
  const columnsPendingRefillAlertsRequest: GridColDef[] = [
    {
      field: "drugDescription",
      headerName: "Drug Description",
      width: 300,
      cellClassName: "w60",
      headerClassName: "w60",
    },
    {
      field: "drugType",
      headerName: "Drug Type",
      width: 150,
      cellClassName: "w40",
      headerClassName: "w40",
    },
  ];

  return (
    <Grid
      container
      xs={12}
      alignItems="center"
      justifyContent="center"
      spacing={0}
    >
      <Grid item xs={12}>
        {" "}
        <DataGridListStyle>
          <DataGrid
            rows={matchingDrugList ?? []}
            headerHeight={36}
            sortingOrder={["desc", "asc"]}
            columns={columnsPendingRefillAlertsRequest}
            autoHeight
            rowHeight={40}
            getRowId={(row) => row?.drugId ?? uuid()}
            pageSize={10}
            rowsPerPageOptions={[10]}
            disableSelectionOnClick
          />
        </DataGridListStyle>
      </Grid>{" "}
    </Grid>
  );
}
